// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5271) return "5271.fdc487681c2b4e6e32c9.js";
	// return url for filenames based on template
	return "" + {"1167":"79692c1116ab2a27a27e","4446":"480227db8287f415ab97"}[chunkId] + ".js";
};